import store from 'ManageBilling/store'
import { Provider } from 'react-redux'
import Billing from './Billing'

export default function SurveyBuilder(params) {
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <Billing {...params} />
      </ErrorBoundary>
    </Provider>
  )
}

